import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Plus, Printer, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";

export default function Memos() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const load = () => api.get("/memos").then(({data})=>setItems(data)).catch((e)=>toast.error(formatApiError(e.response?.data?.detail)));
  useEffect(()=>{ load(); }, []);
  const remove = async (id) => { if (!confirm("Delete this memo?")) return; await api.delete(`/memos/${id}`); toast.success("Deleted"); load(); };

  const filtered = items.filter(m => !q || `${m.memo_no} ${m.truck_no} ${m.owner_name} ${m.driver_name}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="p-8" data-testid="memos-page">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h1 className="font-display text-3xl text-slate-900">Freight Memos</h1>
          <p className="text-slate-500 text-sm">Truck owner / driver memos</p>
        </div>
        <Link to="/portal/memos/new" className="btn-primary px-4 py-2 rounded-lg text-sm font-medium inline-flex items-center gap-2" data-testid="new-memo-btn"><Plus size={16}/> New Memo</Link>
      </div>
      <div className="bg-white border border-slate-100 rounded-xl">
        <div className="p-4 border-b border-slate-100"><Input placeholder="Search by memo no, truck, owner…" value={q} onChange={(e)=>setQ(e.target.value)} data-testid="memos-search"/></div>
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600">
            <tr>
              <th className="text-left px-4 py-2">Memo No</th>
              <th className="text-left px-4 py-2">Date</th>
              <th className="text-left px-4 py-2">Truck</th>
              <th className="text-left px-4 py-2">Owner</th>
              <th className="text-left px-4 py-2">Driver</th>
              <th className="text-right px-4 py-2">Balance</th>
              <th className="text-right px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-slate-400">No memos yet.</td></tr>}
            {filtered.map(m => (
              <tr key={m.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-2 font-mono text-[#0b5cc4]">{m.memo_no}</td>
                <td className="px-4 py-2">{m.date}</td>
                <td className="px-4 py-2">{m.truck_no}</td>
                <td className="px-4 py-2">{m.owner_name}</td>
                <td className="px-4 py-2">{m.driver_name}</td>
                <td className="px-4 py-2 text-right">₹ {m.balance}</td>
                <td className="px-4 py-2">
                  <div className="flex justify-end gap-1">
                    <Link to={`/portal/memos/${m.id}/print`} className="p-2 hover:bg-slate-100 rounded"><Printer size={16}/></Link>
                    <Link to={`/portal/memos/${m.id}/edit`} className="p-2 hover:bg-slate-100 rounded"><Pencil size={16}/></Link>
                    <button onClick={()=>remove(m.id)} className="p-2 hover:bg-red-50 rounded text-red-600"><Trash2 size={16}/></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table></div>
      </div>
    </div>
  );
}
